import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import { MainContextProvider } from "./MainContext";
import 'animate.css';
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <MainContextProvider>
        <App />
    </MainContextProvider>
);
